module.exports = __webpack_public_path__ + "static/media/instagram.fe6b3919.svg";